import React, { useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import SEO from "@/components/SEO";
import VoiceCard from "@/components/VoiceCard";
import { Sparkles, ArrowRight, Gauge, Languages, Zap, Loader2 } from "lucide-react";

const LANGS = ["Engels","Nederlands","Duits","Frans","Spaans","Italiaans","Japans","Chinees","Koreaans","Portugees","Hindi","Turks","Russisch","Arabisch","Zweeds","Deens","Noors","Pools","Grieks","Roemeens","Vietnamees","Indonesisch","Hongaars","Tsjechisch","Fins","Kroatisch","Oekraïens","Tamil","Bulgaars","Sloveens"];

export default function AIVoices() {
  const [ai, setAi] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/voices", { params: { voice_type: "ai" } }).then((r) => setAi(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <SEO title="AI-kinderstemmen — Premium AI-stemgenerator voor kinderen" path="/ai-voices"
        description="30 exclusieve AI-kinderstemmen in 30+ talen met bediening voor toonhoogte, snelheid en emotie. Genereer direct natuurlijke jonge stemmen." />
      <section className="relative overflow-hidden bg-brand-ink text-white">
        <div className="container-x relative py-16 md:py-20">
          <span className="label-eyebrow inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5"><Sparkles size={13} /> VoiceOverKids AI</span>
          <h1 className="mt-5 font-heading text-4xl font-black tracking-tighter md:text-6xl">AI-kinderstemmen</h1>
          <p className="mt-4 max-w-2xl text-lg text-zinc-300">Genereer in seconden natuurlijk klinkende AI-kinderstemmen. 30 exclusieve stemmen in 30+ talen — perfect voor e-learning, animatie, apps en luisterboeken.</p>
          <a href="https://app.voiceoverkids.agency/main" target="_blank" rel="noreferrer" data-testid="ai-cta"
            onClick={() => window.gtag && window.gtag("event", "ai_cta_clicked")}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-violet px-8 py-4 font-bold shadow-lg shadow-violet-500/30 transition hover:bg-brand-violetHover">
            Probeer onze AI-stemmen zelf <ArrowRight size={18} />
          </a>
          <p className="mt-3 text-sm text-zinc-400">Geen abonnement, geen creditcard nodig · 1 gratis token bij aanmelding</p>
        </div>
      </section>

      <section className="container-x section-y">
        <div className="grid gap-6 md:grid-cols-3">
          {[[Sparkles, "Exclusieve stemmen", "30 unieke AI-kinderstemmen, door onszelf ontwikkeld en exclusief beschikbaar bij VoiceOverKids.Agency."],
            [Gauge, "Volledige controle", "Stem toonhoogte, snelheid en emotie nauwkeurig af met versie 2.0."],
            [Languages, "30+ talen", "Plak je script — de generator herkent de taal automatisch."]].map(([Icon, t, d]) => (
            <div key={t} className="rounded-2xl border border-zinc-200 bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><Icon size={20} /></span>
              <h3 className="mt-4 font-heading text-lg font-bold">{t}</h3>
              <p className="mt-1 text-sm text-zinc-500">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white section-y">
        <div className="container-x">
          <div className="mb-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
            <strong>Let op:</strong> dit zijn door AI gegenereerde stemmen, geen opnames van echte kinderen.
          </div>
          <h2 className="font-heading text-3xl font-bold tracking-tight">AI-stemvoorbeelden</h2>
          <p className="mt-2 mb-8 text-zinc-600">Beluister een selectie van onze AI-kinderstemmen die je direct in de generator kunt gebruiken.</p>
          {loading ? <div className="flex justify-center py-20 text-brand-violet"><Loader2 className="animate-spin" size={28} /></div>
            : <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">{ai.map((t) => <VoiceCard key={t.id} talent={t} />)}</div>}
        </div>
      </section>

      <section className="container-x section-y">
        <h2 className="font-heading text-2xl font-bold">Ondersteunde talen</h2>
        <div className="mt-5 flex flex-wrap gap-2">
          {LANGS.map((l) => <span key={l} className="rounded-full bg-zinc-100 px-4 py-1.5 text-sm font-medium text-zinc-700">{l}</span>)}
        </div>
      </section>
    </>
  );
}
